export default __webpack_public_path__ + "static/media/quickContactsPC_mobile.08663f69.png";